import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import MultiSelectAutocomplete from "./base/MultiSelectAutoComplete";

const SelectMultipleAgents = ({ agents, loading, error, selectedAgents, setSelectedAgents }) => (
  <MultiSelectAutocomplete
    options={agents}
    selected={selectedAgents}
    onChange={setSelectedAgents}
    label={<FormattedMessage id="app.agents" />}
    loading={loading}
    error={error}
  />
);

export default injectIntl(SelectMultipleAgents);
